import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CapexInvoiceList from "./CapexInvoiceList";
import {getCapexContractInvoice, updateCapexStatus} from "services/redux/sales/postSales/action";

const mapStateToProps = (state) => ({
    capexContractInvoice: state.postSalesReducer.capexContractInvoice,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getCapexContractInvoice,
            updateCapexStatus
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CapexInvoiceList);
